var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * LinkBroken component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconLinkBroken extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.069 2.94663C12.069 2.52308 11.737 2.18188 11.3249 2.18188C10.9128 2.18188 10.5809 2.52308 10.5809 2.94663V4.33494C10.5809 4.7585 10.9128 5.09969 11.3249 5.09969C11.737 5.09969 12.069 4.7585 12.069 4.33494V2.94663ZM5.37186 2.40541C5.65804 2.11128 6.12737 2.11128 6.41355 2.40541L9.12651 5.1938C9.41269 5.48794 9.41269 5.97031 9.12651 6.26445C8.84033 6.55858 8.371 6.55858 8.08482 6.26445L5.37186 3.47606C5.08568 3.18193 5.08568 2.69955 5.37186 2.40541ZM5.15403 8.51171C5.15403 8.08815 5.486 7.74696 5.89809 7.74696H7.24885C7.66095 7.74696 7.99291 8.08815 7.99291 8.51171C7.99291 8.93526 7.66095 9.27645 7.24885 9.27645H5.89809C5.486 9.27645 5.15403 8.93526 5.15403 8.51171ZM13.2932 7.1233L13.2933 7.11154C13.2994 7.52962 13.629 7.86452 14.0373 7.86452H18.101C18.9939 7.86452 19.8295 8.21748 20.4591 8.86457C21.0773 9.51167 21.4321 10.3705 21.4321 11.2882C21.4321 12.2059 21.0887 13.0648 20.4591 13.7119C19.8295 14.3472 18.9824 14.7119 18.101 14.7119H14.0373C13.6252 14.7119 13.2932 15.0531 13.2932 15.4767C13.2932 15.9002 13.6252 16.2414 14.0373 16.2414H18.101C19.3716 16.2414 20.5965 15.7238 21.5008 14.7943C22.4051 13.8648 22.9088 12.606 22.9088 11.3C22.9088 9.99405 22.4051 8.73515 21.5008 7.80569C20.5965 6.87623 19.3716 6.35855 18.101 6.35855H14.0373C13.629 6.35855 13.2994 6.69345 13.2933 7.11154L13.2932 7.09977V7.1233ZM5.94466 11.9943C6.23084 11.7001 6.23084 11.2177 5.94466 10.9236C5.65849 10.6295 5.18916 10.6295 4.90298 10.9236L2.51053 13.3826C1.60621 14.312 1.10254 15.5709 1.10254 16.8769C1.10254 18.1828 1.60621 19.4417 2.51053 20.3712C3.41485 21.3007 4.63969 21.8183 5.91032 21.8183C7.18095 21.8183 8.40579 21.3007 9.31011 20.3712L11.7026 17.9122C11.9887 17.6181 11.9887 17.1357 11.7026 16.8416C11.4164 16.5475 10.947 16.5475 10.6609 16.8416L8.26843 19.3005C7.63884 19.9359 6.8032 20.3006 5.91032 20.3006C5.01745 20.3006 4.18181 19.9476 3.55222 19.3005C2.93408 18.6534 2.57922 17.7946 2.57922 16.8769C2.57922 15.9592 2.92263 15.1003 3.55222 14.4532L5.94466 11.9943Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconLinkBroken.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconLinkBroken.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconLinkBroken.prototype, "size", void 0);
if (customElements.get('cat-icon-link-broken') === undefined) {
    customElements.define('cat-icon-link-broken', BlocksIconLinkBroken);
}
